import axios from "axios";
import postscribe from "postscribe";
import alertify from "alertifyjs";
import { createTheme } from "@material-ui/core/styles";
import "alertifyjs/build/css/alertify.min.css";
import "alertifyjs/build/css/themes/bootstrap.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as React from "react";
import "@fontsource/quicksand";

alertify.defaults.transition = "zoom";
alertify.defaults.theme.ok = "btn btn-primary";
alertify.defaults.theme.cancel = "btn btn-danger";
alertify.defaults.theme.input = "form-control";

/**
 * Array.isArray() Pollyfill
 * The following code will create Array.isArray() if it's not natively available
 */
if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
  };
}

// Global constants


export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const STL_URL = process.env.REACT_APP_STL_URL;
export const APP_VERSION = process.env.REACT_APP_APP_VERSION;
export const STL_LINKEDIN_URL = process.env.REACT_APP_STL_LINKEDIN_URL;
  
export const STL_FACEBOOK_URL = process.env.REACT_APP_STL_FACEBOOK_URL;
export const STL_TWITTER_URL = process.env.REACT_APP_STL_TWITTER_URL;

//Zoom constants
export const ZOOM_API_KEY = process.env.REACT_APP_ZOOM_API_KEY;
export const ZOOM_API_SECRET = process.env.REACT_APP_ZOOM_API_SECRET;

export const ACTIVE_LINK_COLOR = () => {
  let color = "";
  color = JSON.parse(
    localStorage.getItem("remark.material.iconbar.skinTools")
  ).primary;
  return color;
};

// Left navigation link action dispatch types
export const BACHELOR_LINK_CLICKED = "BACHELOR_LINK_CLICKED";
export const CHILD_LINK_CLICKED = "CHILD_LINK_CLICKED";
export const GRAND_CHILD_LINK_CLICKED = "GRAND_CHILD_LINK_CLICKED";

// Company logo, user image and document Instance
export const BLOB_INSTANCE = axios.create({
  baseURL: API_BASE_URL,
  responseType: "blob",
});

// Check if date is valid
export const dateIsValid = (date) => date.getTime() && !isNaN(date);

// Object array check
export const IS_ARRAY = (obj) => Array.isArray(obj);

// Object empty check
export const IS_EMPTY = (i) => {
  for (let x in i) return !i.hasOwnProperty(x);
  return true;
};

export function useFirstRender() {
  const firstRender = React.useRef(true);

  React.useEffect(() => {
    firstRender.current = false;
  }, []);

  return firstRender.current;
}

export const ItemTypes = {
  Folder: "folder",
};

// Convert file sizes from bytes
export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

///end of evance and briliant changes

// Convert base64 string to Blob
export const b64_TO_BLOB = (b64String, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64String);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) byteNumbers[i] = slice.charCodeAt(i);

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

// Split an array into chunks
export const ARRAY_SPLIT = (array, itemsPerChunk) =>
  array.reduce((result, item, index) => {
    const chunkIndex = Math.floor(index / itemsPerChunk);

    // start a new chunk
    if (!result[chunkIndex]) result[chunkIndex] = [];

    result[chunkIndex].push(item);

    return result;
  }, []);

// Convert string to JSON serializable
export const TO_JSON_SERIALIZABLE = (string) =>
  string.trim().toLowerCase().replace(/ /g, "_");

// Dismiss the systemmega menu
export const DISMISS_MEGA_MENU = () =>
  document.querySelector("#mega-menu").click();

// System table theme
export const EBOARD_TABLE_THEME = () =>
  createTheme({
    overrides: {
      MuiTypography: {
        fontFamily: "quicksand, sans-serif",
      },
      MUIDataTableHeadRow: {
        root: {
          borderBottom: "2px solid #e0e0e0",
        },
      },
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
          padding: "3em",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiCheckbox: {
        root: {
          padding: "5px",
        },
      },
      MUIDataTableHeadCell: {
        root: {
          // color: '#616161',
          fontSize: ".93rem",
          fontWeight: 500,
          fontFamily: "quicksand, sans-serif",
        },
      },
      MUIDataTableBodyCell: {
        root: {
          color: "#757575",
          fontSize: ".9rem",
          fontWeight: 700,
          fontFamily: "quicksand , sans- serif",
        },
      },
    },
  });

// Confirm alert
export const CONFIRM_ALERT = (title, message, confirmFunction) =>
  confirmAlert({
    title: title,
    message: message,
    buttons: [
      {
        label: "Yes",
        onClick: () => confirmFunction(),
      },
      {
        label: "No",
        onClick: () => null,
      },
    ],
  });

// Strip HTML tags from string
export const STRIP_HTML_TAGS = (string) => {
  if (string === null || string === "") return false;
  else string = string.toString();

  return string.replace(/<[^>]*>/g, "");
};

export const APPEND_SCRIPTS = (scripts) =>
  scripts.map((source) => {
    const script = document.createElement("script");

    script.src = source;
    script.async = true;

    return document.body.appendChild(script);
  });

// HTTP error handling
export const HANDLE_HTTP_ERRORS = (error) => {};

// Generate form control props
export const FORM_CONTROL_PROPS_GENERATOR = (
  formControl,
  formControlConfig,
  value
) => {
  return {
    formControl: formControl,
    formControlConfig: formControlConfig,
    value: value,
  };
};

// Generate random string
export const RANDOM_STRING = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++)
    result += characters.charAt(Math.floor(Math.random() * charactersLength));

  return result;
};

// Dependant component scripts
export const FOO_TABLE_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="moment" src="/assets/global/vendor/moment/moment.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="footable" src="/assets/global/vendor/footable/footable.min.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="footable" src="/assets/js/tables/footable.js"></script>'
  );
};

export const FOO_TABLE_SCRIPTS_DEQUEUE = () => {
  const moment = document.querySelector("#moment");
  moment.parentNode.removeChild(moment);

  const footable = document.querySelector("#footable");
  footable.parentNode.removeChild(footable);
};

export const FORM_VALIDATION_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="formValidation-vendor" src="/assets/global/vendor/formvalidation/formValidation.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="bootstrap4-vendor" src="/assets/global/vendor/formvalidation/framework/bootstrap4.min.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="validation-starter" src="/assets/js/forms/validation.js?v=2"></script>'
  );
};

export const FORM_VALIDATION_SCRIPTS_DEQUEUE = () => {
  const formValidationvendor = document.querySelector("#formValidation-vendor");
  if (formValidationvendor) {
    formValidationvendor.parentNode.removeChild(formValidationvendor);
  }

  const bootstrap4vendor = document.querySelector("#bootstrap4-vendor");
  if (bootstrap4vendor) {
    bootstrap4vendor.parentNode.removeChild(bootstrap4vendor);
  }

  const validationstarter = document.querySelector("#validation-starter");
  if (validationstarter) {
    validationstarter.parentNode.removeChild(validationstarter);
  }
};

export const MATERIAL_FORM_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="jquery-placeholder-vendor" src="/assets/global/vendor/jquery-placeholder/jquery.placeholder.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="jquery-placeholder-plugin" src="/assets/global/js/Plugin/jquery-placeholder.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="material-plugin" src="/assets/global/js/Plugin/material.js"></script>'
  );
};

export const MATERIAL_FORM_SCRIPTS_DEQUEUE = () => {
  const jqueryplaceholdervendor = document.querySelector(
    "#jquery-placeholder-vendor"
  );
  jqueryplaceholdervendor.parentNode.removeChild(jqueryplaceholdervendor);

  const jqueryplaceholderplugin = document.querySelector(
    "#jquery-placeholder-plugin"
  );
  jqueryplaceholderplugin.parentNode.removeChild(jqueryplaceholderplugin);

  const materialplugin = document.querySelector("#material-plugin");
  materialplugin.parentNode.removeChild(materialplugin);
};

export const CSS3_CHART_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="d3" src="/assets/global/vendor/d3/d3.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="c3" src="/assets/global/vendor/c3/c3.min.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="c3js" src="/assets/js/charts/c3.js"></script>'
  );
};

export const CSS3_CHART_SCRIPTS_DEQUEUE = () => {
  const d3 = document.querySelector("#d3");
  d3.parentNode.removeChild(d3);

  const c3 = document.querySelector("#c3");
  c3.parentNode.removeChild(c3);

  const c3js = document.querySelector("#c3js");
  c3js.parentNode.removeChild(c3js);
};

export const USERS_SCRIPTS_QUEUE = () => {
  postscribe(
    "#core",
    '<script id="jqueryasScrollable" src="/assets/global/vendor/asscrollable/jquery-asScrollable.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="bootbox" src="/assets/global/vendor/bootbox/bootbox.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="stickyheader" src="/assets/global/js/Plugin/sticky-header.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="asselectable" src="/assets/global/js/Plugin/asselectable.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="aspaginator" src="/assets/global/js/Plugin/aspaginator.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="animatelist" src="/assets/global/js/Plugin/animate-list.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="jqueryplaceholder" src="/assets/global/js/Plugin/jquery-placeholder.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="selectable" src="/assets/global/js/Plugin/selectable.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="bootboxPlugin" src="/assets/global/js/Plugin/bootbox.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="BaseApp" src="/assets/js/BaseApp.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="Contacts" src="/assets/js/App/Contacts.js?v=3"></script>'
  );
  postscribe(
    "#page",
    '<script id="contactsStarter" src="/assets/js/apps/contacts.js"></script>'
  );
};

export const USERS_SCRIPTS_DEQUEUE = () => {
  const jqueryasScrollable = document.querySelector("#jquery-asScrollable");
  if (jqueryasScrollable)
    jqueryasScrollable.parentNode.removeChild(jqueryasScrollable);

  const bootbox = document.querySelector("#bootbox");
  if (bootbox) bootbox.parentNode.removeChild(bootbox);

  const stickyheader = document.querySelector("#stickyheader");
  if (stickyheader) stickyheader.parentNode.removeChild(stickyheader);

  const asselectable = document.querySelector("#asselectable");
  if (asselectable) asselectable.parentNode.removeChild(asselectable);

  const aspaginator = document.querySelector("#aspaginator");
  if (aspaginator) aspaginator.parentNode.removeChild(aspaginator);

  const animatelist = document.querySelector("#animatelist");
  if (animatelist) animatelist.parentNode.removeChild(animatelist);

  const jqueryplaceholder = document.querySelector("#jqueryplaceholder");
  if (jqueryplaceholder)
    jqueryplaceholder.parentNode.removeChild(jqueryplaceholder);

  const selectable = document.querySelector("#selectable");
  if (selectable) selectable.parentNode.removeChild(selectable);

  const bootboxPlugin = document.querySelector("#bootboxPlugin");
  if (bootboxPlugin) bootboxPlugin.parentNode.removeChild(bootboxPlugin);

  const BaseApp = document.querySelector("#BaseApp");
  if (BaseApp) BaseApp.parentNode.removeChild(BaseApp);

  const Contacts = document.querySelector("#Contacts");
  if (Contacts) Contacts.parentNode.removeChild(Contacts);

  const contactsStarter = document.querySelector("#contactsStarter");
  if (contactsStarter) contactsStarter.parentNode.removeChild(contactsStarter);

  const toolbar = document.querySelector("#toolbar");
  if (toolbar) toolbar.parentNode.removeChild(toolbar);
};

export const TOOLBAR_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="jquerywebuipopover" src="/assets/global/vendor/webui-popover/jquery.webui-popover.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="jquerytoolbar" src="/assets/global/vendor/toolbar/jquery.toolbar.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="webuipopover" src="/assets/global/js/Plugin/webui-popover.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="toolbar" src="/assets/global/js/Plugin/toolbar.js"></script>'
  );
};

export const TOOLBAR_SCRIPTS_DEQUEUE = () => {
  const jquerywebuipopover = document.querySelector("#jquerywebuipopover");
  jquerywebuipopover.parentNode.removeChild(jquerywebuipopover);

  const jquerytoolbar = document.querySelector("#jquerytoolbar");
  jquerytoolbar.parentNode.removeChild(jquerytoolbar);

  const webuipopover = document.querySelector("#webuipopover");
  webuipopover.parentNode.removeChild(webuipopover);

  const toolbar = document.querySelector("#toolbar");
  toolbar.parentNode.removeChild(toolbar);
};

export const CONTEXT_MENU_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="jqueryContextMenu" src="/assets/global/vendor/jquery-contextmenu/jquery.contextMenu.js"></script>'
  );
  // postscribe(
  //   "#page",
  //   '<script id="actionButton" src="/assets/global/js/Plugin/action-btn.js"></script>'
  // );
  postscribe(
    "#page",
    '<script id="Notebook" src="/assets/js/App/Notebook.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="notebook" src="/assets/js/apps/notebook.js"></script>'
  );
};

export const CONTEXT_MENU_SCRIPTS_DEQUEUE = () => {
  const jqueryContextMenu = document.querySelector("#jqueryContextMenu");
  if (jqueryContextMenu) {
    jqueryContextMenu.parentNode.removeChild(jqueryContextMenu);
  }

  const asscrollable = document.querySelector("#asscrollable");
  if (asscrollable) {
    asscrollable.parentNode.removeChild(asscrollable);
  }

  const Notebook = document.querySelector("#Notebook");
  if (Notebook) {
    Notebook.parentNode.removeChild(Notebook);
  }

  const notebook = document.querySelector("#notebook");
  if (notebook) {
    notebook.parentNode.removeChild(notebook);
  }

  // const actionButton = document.querySelector("#actionButton");
  // if (actionButton) {
  //   actionButton.parentNode.removeChild(actionButton);
  // }
};

export const COLOR_PICKER_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="jquery-asColor-color" src="/assets/global/vendor/ascolor/jquery-asColor.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="jquery-asGradient" src="/assets/global/vendor/asgradient/jquery-asGradient.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="jquery-asColorPicker-vendor" src="/assets/global/vendor/ascolorpicker/jquery-asColorPicker.min.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="ascolorpicker-plugin" src="/assets/global/js/Plugin/ascolorpicker.js"></script>'
  );
};

export const COLOR_PICKER_SCRIPTS_DEQUEUE = () => {
  const jqueryasColorcolor = document.querySelector("#jquery-asColor-color");
  if (jqueryasColorcolor) {
    jqueryasColorcolor.parentNode.removeChild(jqueryasColorcolor);
  }

  const jqueryasColorPickervendor = document.querySelector(
    "#jquery-asColorPicker-vendor"
  );
  if (jqueryasColorPickervendor) {
    jqueryasColorPickervendor.parentNode.removeChild(jqueryasColorPickervendor);
  }

  const jqueryasGradient = document.querySelector("#jquery-asGradient");
  if (jqueryasGradient) {
    jqueryasGradient.parentNode.removeChild(jqueryasGradient);
  }

  const ascolorpickerplugin = document.querySelector("#ascolorpicker-plugin");
  if (ascolorpickerplugin) {
    ascolorpickerplugin.parentNode.removeChild(ascolorpickerplugin);
  }
};

export const DATE_PICKER_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="bootstrap-datepicker-vendor" src="/assets/global/vendor/bootstrap-datepicker/bootstrap-datepicker.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="bootstrap-datepicker-plugin" src="/assets/global/js/Plugin/bootstrap-datepicker.js"></script>'
  );
};

export const DATE_PICKER_SCRIPTS_DEQUEUE = () => {
  const bootstrapdatepickervendor = document.querySelector(
    "#bootstrap-datepicker-vendor"
  );
  if (bootstrapdatepickervendor)
    bootstrapdatepickervendor.parentNode.removeChild(bootstrapdatepickervendor);

  const bootstrapdatepickerplugin = document.querySelector(
    "#bootstrap-datepicker-plugin"
  );
  if (bootstrapdatepickerplugin)
    bootstrapdatepickerplugin.parentNode.removeChild(bootstrapdatepickerplugin);
};

export const FORM_WIZARD_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="formValidation-vendor" src="/assets/global/vendor/formvalidation/formValidation.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="formvalidation-bootstrap-framework-vendor" src="/assets/global/vendor/formvalidation/framework/bootstrap.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="jquery-matchHeight-min-vendor" src="/assets/global/vendor/matchheight/jquery.matchHeight-min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="jquery-wizard-vendor" src="/assets/global/vendor/jquery-wizard/jquery-wizard.js?v=3"></script>'
  );
  postscribe(
    "#page",
    '<script id="jquery-wizard-plugin" src="/assets/global/js/Plugin/jquery-wizard.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="matchheight-plugin" src="/assets/global/js/Plugin/matchheight.js"></script>'
  );
};

export const FORM_WIZARD_SCRIPTS_DEQUEUE = () => {
  const formValidationvendor = document.querySelector("#formValidation-vendor");
  if (formValidationvendor)
    formValidationvendor.parentNode.removeChild(formValidationvendor);

  const formvalidationbootstrapframeworkvendor = document.querySelector(
    "#formvalidation-bootstrap-framework-vendor"
  );
  if (formvalidationbootstrapframeworkvendor)
    formvalidationbootstrapframeworkvendor.parentNode.removeChild(
      formvalidationbootstrapframeworkvendor
    );

  const jquerymatchHeightminvendor = document.querySelector(
    "#jquery-matchHeight-min-vendor"
  );
  if (jquerymatchHeightminvendor)
    jquerymatchHeightminvendor.parentNode.removeChild(
      jquerymatchHeightminvendor
    );

  const jquerywizardvendor = document.querySelector("#jquery-wizard-vendor");
  if (jquerywizardvendor)
    jquerywizardvendor.parentNode.removeChild(jquerywizardvendor);

  const jquerywizardplugin = document.querySelector("#jquery-wizard-plugin");
  if (jquerywizardplugin)
    jquerywizardplugin.parentNode.removeChild(jquerywizardplugin);

  const matchheightplugin = document.querySelector("#matchheight-plugin");
  if (matchheightplugin)
    matchheightplugin.parentNode.removeChild(matchheightplugin);
};

export const BUTTONS_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="spin-vendor" src="/assets/global/vendor/ladda/spin.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="ladda-vendor" src="/assets/global/vendor/ladda/ladda.min.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="loading-button-plugin" src="/assets/global/js/Plugin/loading-button.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="more-button-plugin" src="/assets/global/js/Plugin/more-button.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="ladda-plugin" src="/assets/global/js/Plugin/ladda.js"></script>'
  );
};

export const BUTTONS_SCRIPTS_DEQUEUE = () => {};

export const DASHBOARD_SCRIPTS_QUEUE = () => {
  postscribe(
    "#plugins",
    '<script id="jquery-ui-vendor" src="/assets/global/vendor/jquery-ui/jquery-ui.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="moment-vendor" src="/assets/global/vendor/moment/moment.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="fullcalendar-vendor" src="/assets/global/vendor/fullcalendar/fullcalendar.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="jquery-selective-vendor" src="/assets/global/vendor/jquery-selective/jquery-selective.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="bootstrap-datepicker-vendor" src="/assets/global/vendor/bootstrap-datepicker/bootstrap-datepicker.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="bootstrap-touchspin-vendor" src="/assets/global/vendor/bootstrap-touchspin/bootstrap-touchspin.min.js"></script>'
  );
  postscribe(
    "#plugins",
    '<script id="bootbox-vendor" src="/assets/global/vendor/bootbox/bootbox.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="bootstrap-touchspin-plugin" src="/assets/global/js/Plugin/bootstrap-touchspin.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="bootstrap-datepicker-plugin" src="/assets/global/js/Plugin/bootstrap-datepicker.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="material-plugin" src="/assets/global/js/Plugin/material.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="action-btn-plugin" src="/assets/global/js/Plugin/action-btn.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="editlist-plugin" src="/assets/global/js/Plugin/editlist.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="bootbox-plugin" src="/assets/global/js/Plugin/bootbox.js"></script>'
  );
  postscribe(
    "#page",
    '<script id="Calendar-App" src="/assets/js/App/Calendar.js?v=2"></script>'
  );
  postscribe(
    "#page",
    '<script id="calendar-starter" src="/assets/js/apps/calendar.js"></script>'
  );
};

export const DASHBOARD_SCRIPTS_DEQUEUE = () => {
  const jqueryuivendor = document.querySelector("#jquery-ui-vendor");
  if (jqueryuivendor) {
    jqueryuivendor.parentNode.removeChild(jqueryuivendor);
  }

  const momentvendor = document.querySelector("#moment-vendor");
  if (momentvendor) {
    momentvendor.parentNode.removeChild(momentvendor);
  }

  const fullcalendarvendor = document.querySelector("#fullcalendar-vendor");
  if (fullcalendarvendor) {
    fullcalendarvendor.parentNode.removeChild(fullcalendarvendor);
  }

  const jqueryselectivevendor = document.querySelector(
    "#jquery-selective-vendor"
  );
  if (jqueryselectivevendor) {
    jqueryselectivevendor.parentNode.removeChild(jqueryselectivevendor);
  }

  const bootstrapdatepickervendor = document.querySelector(
    "#bootstrap-datepicker-vendor"
  );
  if (bootstrapdatepickervendor) {
    bootstrapdatepickervendor.parentNode.removeChild(bootstrapdatepickervendor);
  }

  const bootstraptouchspinvendor = document.querySelector(
    "#bootstrap-touchspin-vendor"
  );
  if (bootstraptouchspinvendor) {
    bootstraptouchspinvendor.parentNode.removeChild(bootstraptouchspinvendor);
  }

  const bootboxvendor = document.querySelector("#bootbox-vendor");
  if (bootboxvendor) {
    bootboxvendor.parentNode.removeChild(bootboxvendor);
  }

  const bootstraptouchspinplugin = document.querySelector(
    "#bootstrap-touchspin-plugin"
  );
  if (bootstraptouchspinplugin) {
    bootstraptouchspinplugin.parentNode.removeChild(bootstraptouchspinplugin);
  }

  const bootstrapdatepickerplugin = document.querySelector(
    "#bootstrap-datepicker-plugin"
  );
  if (bootstrapdatepickerplugin) {
    bootstrapdatepickerplugin.parentNode.removeChild(bootstrapdatepickerplugin);
  }

  const materialplugin = document.querySelector("#material-plugin");
  if (materialplugin) {
    materialplugin.parentNode.removeChild(materialplugin);
  }

  const actionbtnplugin = document.querySelector("#action-btn-plugin");
  if (actionbtnplugin) {
    actionbtnplugin.parentNode.removeChild(actionbtnplugin);
  }

  const editlistplugin = document.querySelector("#editlist-plugin");
  if (editlistplugin) {
    editlistplugin.parentNode.removeChild(editlistplugin);
  }

  const bootboxplugin = document.querySelector("#bootbox-plugin");
  if (bootboxplugin) {
    bootboxplugin.parentNode.removeChild(bootboxplugin);
  }

  const CalendarApp = document.querySelector("#Calendar-App");
  if (CalendarApp) {
    CalendarApp.parentNode.removeChild(CalendarApp);
  }

  const calendarstarter = document.querySelector("#calendar-starter");
  if (calendarstarter) {
    calendarstarter.parentNode.removeChild(calendarstarter);
  }
};
